export default {
  init() {
    // JavaScript to be fired on the home page
    /* Slider */
    $('.home-slider').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      autoplay: true,
    });
    /* END Slider */

    $('.home-actu-slider').owlCarousel({
      loop: true,
      margin: 50,
      nav: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        991: {
          items: 3,
        },
      },
    });


    /* Partenaires */
    $('.home-partenaires').owlCarousel({
      loop: true,
      margin: 50,
      autoplay: true,
      nav: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 3,
        },
        991: {
          items: 5,
        },
        1200: {
          items: 6,
        },
      },
    });
    /* END Partenaires */
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js